/// <amd-module name="Test/common-util/Telemetry" />
import * as Utils_String from "VSS/Core/Util/String";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssPageContext } from "VSS/Platform/Context";
import { IViewContextData, ViewContext, ViewContextStatus } from 'Common';
import * as TelemetryConstants from "Test/common-util/TelemetryConstants";

// Logs information to customer intelligence service
// @param(feature) = featureName
// @param(key) = key of the information value
// @param(value) = information value
export function publishEvent(pageContext: IVssPageContext, context: IViewContextData, feature: string, properties: { [key: string]: any }) {
    try {
        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        var artifactStatus, artifactId, artifactType, artifactStageId, artifactContribution;
        if (context && context.status) {
            switch (+context.status) {
                case ViewContextStatus.InProgress: artifactStatus = TelemetryConstants.inProgress; break;
                case ViewContextStatus.Completed: artifactStatus = TelemetryConstants.completed; break;
                case ViewContextStatus.Others: artifactStatus = TelemetryConstants.others; break;
            }
            artifactId = context.data.mainData.id;
            artifactType = context.viewContext === ViewContext.Release ? TelemetryConstants.releaseContext : TelemetryConstants.buildContext;
            if (artifactType === TelemetryConstants.releaseContext) {
                artifactStageId = context.data.subData.environment.id;
            }
            artifactContribution = context.contributionSource;
        }

        properties["artifactType"] = artifactType;
        properties["artifactId"] = artifactId;
        properties["artifactStatus"] = artifactStatus;
        properties["contributionSource"] = artifactContribution;
        if (artifactType === TelemetryConstants.releaseContext) {
            properties["artifactStageId"] = artifactStageId;
        }

        telemetryService.publishEvent(TelemetryConstants.areaTestManagement,
            feature,
            properties);
    }
    catch (e) {
        console.error(Utils_String.format("[TelemetryService.logProperties]: Error in logging Customer Intelligence data. Error: {0}", e.message));
    }
}

// Logs information to customer intelligence service with Details pane mode info
// @param(feature) = featureName
// @param(key) = key of the information value
// @param(value) = information value
export function publishDetailsPaneEvents(pageContext: IVssPageContext, context: IViewContextData, isPaneFullScreen: boolean, feature: string, properties: { [key: string]: any; }) {
    let detailsPaneMode: string = "HalfScreen";
    if(isPaneFullScreen) {
        detailsPaneMode = "FullScreen";
    }
    properties["DetailsPaneMode"] = detailsPaneMode;
    publishEvent(pageContext, context, feature, properties);
}